<top-banner variant="custom">
    <h2 class="title mb-3 animated fadeIn">
      {{typeTitle}}
    </h2>
</top-banner>

<div class="main-content">
  <div class="row">
    <div class="col-md-12">
      <div class="card">
        <div class="row">
          <div *ngIf="actionType === 'edit'" class="col-md-2 cardtabs-wrapper">
            <app-card-tabs [tabitems]="editTabItems"></app-card-tabs>
          </div>
          <div *ngIf="actionType === 'add'" class="col-md-2 cardtabs-wrapper">
            <app-card-tabs [tabitems]="addTabItems"></app-card-tabs>
          </div>
          <div class="col-md-10">
            <div *ngIf="loadingAssetCategories || loadingEditAsset" class="progress-spinner-wrapper">
              <p-progressSpinner></p-progressSpinner>
            </div>
            <ng-container *ngIf="!loadingAssetCategories && !loadingEditAsset">

              <h4 class="card-title">Details</h4>
              <div class="mb-2 animated fadeIn">
                <form [formGroup]="assetForm" (ngSubmit)="onAssetFormSubmit()">
                  <div class="form-row">
                    <div class="col-md-12">
                      <div class="form-group">
                        <label>Categories <span class="required-text">(required)</span></label>
                        <p-multiSelect
                            class="form-control"
                            formControlName="assetCategories"
                            [options]="allAssetCategories"
                            optionLabel="label"
                            defaultLabel='&nbsp;'
                            [style]="{'width':'100%'}"
                        >
                        </p-multiSelect>
                      </div>
                    </div>
                    <div class="col-md-12">
                      <div class="form-group">
                        <label>Name <span class="required-text">(required)</span></label>
                        <input type="text" class="form-control" formControlName="name" placeholder="Enter asset name">
                      </div>
                    </div>
                    <div class="col-md-12">
                      <div class="form-group">
                        <label>Description <span class="required-text">(required)</span></label>
                        <textarea type="text" class="form-control" formControlName="description" placeholder="Enter asset description..."></textarea>
                      </div>
                    </div>
                    <div *ngIf="isTurbineAsset" class="col-md-12">
                      <div class="form-group">
                        <label>Manufacturer</label>
                        <p-dropdown
                            class="form-control"
                            formControlName="manufacturer"
                            [options]="manufacturerOptions"
                            placeholder="Select manufacturer"
                            [style]="{'width':'100%'}"
                        >
                        </p-dropdown>
                      </div>
                    </div>
                    <div *ngIf="isTurbineAsset" class="col-md-12">
                      <div class="form-group">
                        <label>Model</label>
                        <p-dropdown
                            class="form-control"
                            formControlName="model"
                            [options]="modelOptions"
                            placeholder="Select model"
                            [style]="{'width':'100%'}"
                        >
                        </p-dropdown>
                      </div>
                    </div>
                    <div *ngIf="isTurbineAsset" class="col-md-12">
                      <div class="form-group">
                        <label>Rating (kW)</label>
                        <p-dropdown
                            class="form-control"
                            formControlName="rating"
                            [options]="ratingOptions"
                            placeholder="Select rating"
                            [style]="{'width':'100%'}"
                        >
                        </p-dropdown>
                      </div>
                    </div>
                    <div class="col-md-12">
                      <div class="form-group">
                        <label>Latitude</label>
                        <input
                            type="text"
                            inputmode="decimal"
                            step="any"
                            class="form-control"
                            formControlName="latitude"
                            placeholder="Latitude (-90 to 90)"
                            (keydown)="onCoordinateKeyDown($event)"
                        >
                        <div class="text-danger small mt-1" *ngIf="assetForm.get('latitude').touched && assetForm.get('latitude').invalid">
                          Latitude must be between -90 and 90.
                        </div>
                      </div>
                    </div>
                    <div class="col-md-12">
                      <div class="form-group">
                        <label>Longitude</label>
                        <input
                            type="text"
                            inputmode="decimal"
                            step="any"
                            class="form-control"
                            formControlName="longitude"
                            placeholder="Longitude (-180 to 180)"
                            (keydown)="onCoordinateKeyDown($event)"
                        >
                        <div class="text-danger small mt-1" *ngIf="assetForm.get('longitude').touched && assetForm.get('longitude').invalid">
                          Longitude must be between -180 and 180.
                        </div>
                      </div>
                    </div>
                    <div *ngIf="actionType === 'edit' && allowAssetScheduling" class="col-md-12">
                      <div class="form-group">
                        <label>Exempt From Scheduling</label>
                        <div>
                          <p-inputSwitch formControlName="exemptFromAssetScheduling"></p-inputSwitch>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-12" *ngIf="actionType === 'add'">
                      <div class="form-group">
                        <label for="assetImage" class="btn btn-primary btn-round color_white">Choose Image</label>
                        <span class="required-text ml-2">(required)</span>
                        <input
                            #assetImageInput
                            type="file"
                            class="form-control"
                            name="assetImage"
                            id="assetImage"
                            accept="image/*"
                            (change)="onFileChange($event)"
                        >
                        <ng-container *ngIf="selectedAssetImageArray.length">
                          <p>Selected Image File:</p>
                          <ul>
                            <li *ngFor="let file of selectedAssetImageArray">
                              {{ file.name }}
                              <button type="button" class="btn btn-primary btn-link text-left link-underline" (click)="viewSelectedAssetImage()">
                                <i class="fas fa-search"></i>
                                View
                              </button>
                              <button type="button" class="btn btn-link btn-danger link-underline" (click)="removeSelectedAssetImage()">
                                <i class="fas fa-close"></i>
                                Remove
                              </button>
                            </li>
                          </ul>
                        </ng-container>
                      </div>
                    </div>

                    <div class="col-md-12">
                      <button *ngIf="actionType === 'add'" type="submit" class="btn btn-success btn-round"
                          [disabled]="!assetForm.valid || !areFilesAdded || loadingTurbineOptions || saveInProgress"
                      >
                        Add
                      </button>
                      <button *ngIf="actionType === 'edit'" type="submit" class="btn btn-success btn-round"
                          [disabled]="!assetForm.valid || loadingTurbineOptions || saveInProgress"
                      >
                        Save Changes
                      </button>
                    </div>
                  </div>
                </form>
                <div class="alert alert-warning" role="alert" *ngIf="!assetForm.controls['name'].valid && assetForm.controls['name'].errors?.maxlength">
                  Name cannot be longer than {{ assetForm.controls['name'].errors?.maxlength.requiredLength }} characters
                </div>
                <div class="alert alert-warning" role="alert" *ngIf="!assetForm.controls['description'].valid && assetForm.controls['description'].errors?.maxlength">
                  Description cannot be longer than {{ assetForm.controls['description'].errors?.maxlength.requiredLength }} characters
                </div>
              </div>
            </ng-container>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<p-dialog header="Saving..." [(visible)]="saveInProgress" modal="true" [closable]="false" [resizable]="false" [style]="{'min-height': '50px'}" [baseZIndex]="1000000">
  <div style="width: 50px; margin: 0 auto;">
    <p-progressSpinner [style]="{width: '50px', height: '50px'}" [strokeWidth]="4"></p-progressSpinner>
  </div>
</p-dialog>
